<template>
  <div class="zp" @touchmove.pervent>
    <img
      src="http://cdn.yxvzb.com/WEB/wx-master/images/anyu/zz.png"
      alt=""
      id="spin_button"
      @click="runCup"
    />
    <img
      src="http://cdn.yxvzb.com/WEB/wx-master/images/anyu/c.png"
      alt=""
      class="close"
      @click="close"
    />
    <canvas
      id="canvas"
      width="220"
      height="220"
      :style="{ transform: `rotate(${angles}deg)` }"
    ></canvas>
  </div>
</template>

<script>
import { headline } from '@/api/ajax.js';
import { mapState, mapActions } from 'vuex';
export default {
  props: {
    itemList: {
      type: Array,
      default() {
        return ['5积分', '红包', '下次再来', '10积分', '15积分'];
      }
    },
    showDial: Boolean
  },
  data() {
    return {
      angles: 200, //旋转角度
      rotNum: 0, //旋转次数
      info: ['5积分', '红包', '下次再来', '10积分', '15积分'], // 获取奖品替换数据
      notice: null, //中奖公告
      awards: [
        // 转盘内的奖品个数以及内容
        '5积分',
        '红包',
        '下次再来',
        '10积分',
        '15积分'
      ],
      canRun: true
    };
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  methods: {
    runCup() {
      if (this.canRun) {
        this.canRun = false;
        let num = null;
        let len = this.awards.length;
        //获取随机数0-5 取回获奖数据下标代替 此处获取获奖数据使用异步方法
        // num = parseInt(Math.random() * (len) + 0);
        // 获取结果
        headline
          .drizeDraw({
            wxOpenId: this.wxUserInfo.wxOpenId
          })
          .then(res => {
            let { watchword, integral } = res.data;
            if (watchword) {
              num = 3;
            } else if (integral) {
              if (integral == 5) {
                num = 2;
              } else if (integral == 10) {
                num = 0;
              } else {
                num = 1;
              }
            } else {
              num = 4;
            }

            // 记录旋转的次数，依次叠加旋转度数，防止往回倒转  transform属性的值必须依次增加，否则会发生倒转
            this.rotNum += 1;

            if (num !== null) {
              //  旋转角度 = 旋转6圈（2160度）* 已经旋转的次数 + 最少旋转的圈数（5圈）+ 每个奖品下标对应的角度
              // 1 15，  2 5 ，3红包 4 下次 , 0 10
              this.angles =
                2160 * this.rotNum + 1800 + (360 / len) * (len - num);
              setTimeout(() => {
                let data = { ...res.data, ...{ isDrawed: '1' } };
                this.$emit('getValue', data);
              }, 6 * 1000);
            } else {
              this.angles = 2160 * this.rotNum + 1800;
            }
            // 如果没有获取到获奖数据继续转动
            if (num === null) {
              this.runCup();
            }
          });
      }
    },
    close() {
      this.$emit('canvasClose', false);
    }
  },
  mounted() {
    let canvas = document.getElementById('canvas'),
      context = canvas.getContext('2d'),
      OUTSIDE_RADIUAS = 110, // 转盘的半径
      INSIDE_RADIUAS = 0, // 用于非零环绕原则的内圆半径
      TEXT_RADIUAS = 80, // 转盘内文字的半径
      CENTER_X = canvas.width / 2,
      CENTER_Y = canvas.height / 2,
      startRadian = 0, // 绘制奖项的起始角，改变该值实现旋转效果
      awardRadian = (Math.PI * 2) / this.awards.length, // 每一个奖项所占的弧度
      duration = 4000, // 旋转事件
      velocity = 10, // 旋转速率
      spinningTime = 0, // 旋转当前时间
      spinTotalTime, // 旋转时间总长
      spinningChange; // 旋转变化值的峰值

    /**
     * 缓动函数，由快到慢
     * @param {Num} t 当前时间
     * @param {Num} b 初始值
     * @param {Num} c 变化值
     * @param {Num} d 持续时间
     */
    function easeOut(t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
      return (-c / 2) * (--t * (t - 2) - 1) + b;
    }

    /**
     * 绘制转盘
     */

    let drawRouletteWheel = () => {
      // ----- ① 清空页面元素，用于逐帧动画
      context.clearRect(0, 0, canvas.width, canvas.height);
      // -----

      for (let i = 0; i < this.awards.length; i++) {
        let _startRadian = startRadian + awardRadian * i, // 每一个奖项所占的起始弧度
          _endRadian = _startRadian + awardRadian; // 每一个奖项的终止弧度

        // ----- ② 使用非零环绕原则，绘制圆盘
        context.save();

        if (i === 1) context.fillStyle = '#ffe701';
        else context.fillStyle = '#fdf8dd';
        context.strokeStyle = '#ff2d4c';
        context.beginPath();

        context.arc(
          canvas.width / 2,
          canvas.height / 2,
          OUTSIDE_RADIUAS,
          _startRadian,
          _endRadian,
          false
        );
        context.arc(
          canvas.width / 2,
          canvas.height / 2,
          INSIDE_RADIUAS,
          _endRadian,
          _startRadian,
          true
        );
        context.fill();
        context.stroke();
        context.restore();
        // -----

        // ----- ③ 绘制文字
        context.save();
        context.font = 'bold 16px Helvetica, Arial';
        if (i === 1) context.fillStyle = '#dd0f6b';
        else context.fillStyle = '#000';

        context.translate(
          CENTER_X + Math.cos(_startRadian + awardRadian / 2) * TEXT_RADIUAS,
          CENTER_Y + Math.sin(_startRadian + awardRadian / 2) * TEXT_RADIUAS
        );
        context.rotate(_startRadian + awardRadian / 2 + Math.PI / 2);
        context.fillText(
          this.awards[i],
          -context.measureText(this.awards[i]).width / 2,
          0
        );
        context.restore();
        // -----
      }

      // // ----- ④ 绘制指针
      // context.save();
      // context.beginPath();
      // context.moveTo(CENTER_X, CENTER_Y - OUTSIDE_RADIUAS + 8);
      // context.lineTo(CENTER_X - 10, CENTER_Y - OUTSIDE_RADIUAS);
      // context.lineTo(CENTER_X - 4, CENTER_Y - OUTSIDE_RADIUAS);
      // context.lineTo(CENTER_X - 4, CENTER_Y - OUTSIDE_RADIUAS - 10);
      // context.lineTo(CENTER_X + 4, CENTER_Y - OUTSIDE_RADIUAS - 10);
      // context.lineTo(CENTER_X + 4, CENTER_Y - OUTSIDE_RADIUAS);
      // context.lineTo(CENTER_X + 10, CENTER_Y - OUTSIDE_RADIUAS);
      // context.closePath();
      // context.fill();
      // context.restore();
      // -----
    };

    /**
     * 开始旋转
     */
    let rotateWheel = () => {
      // 当 当前时间 大于 总时间，停止旋转，并返回当前值
      spinningTime += 20;
      if (spinningTime >= spinTotalTime) {
        // console.log(getValue());
        return;
      }

      let _spinningChange =
        (spinningChange -
          easeOut(spinningTime, 0, spinningChange, spinTotalTime)) *
        (Math.PI / 180);
      startRadian += _spinningChange;

      drawRouletteWheel();
      window.requestAnimationFrame(rotateWheel);
    };

    /**
     * 旋转结束，获取值
     */
    function getValue() {
      let startAngle = (startRadian * 180) / Math.PI, // 弧度转换为角度
        awardAngle = (awardRadian * 180) / Math.PI,
        pointerAngle = 90, // 指针所指向区域的度数，该值控制选取哪个角度的值
        overAngle = (startAngle + pointerAngle) % 360, // 无论转盘旋转了多少圈，产生了多大的任意角，我们只需要求到当前位置起始角在360°范围内的角度值
        restAngle = 360 - overAngle, // 360°减去已旋转的角度值，就是剩下的角度值
        index = Math.floor(restAngle / awardAngle); // 剩下的角度值 除以 每一个奖品的角度值，就能得到这是第几个奖品

      return this.awards[index];
    }

    drawRouletteWheel();

    // document.getElementById('spin_button').addEventListener('click', () => {
    //     spinningTime = 0; // 初始化当前时间
    //     spinTotalTime = Math.random() * 3 + duration; // 随机定义一个时间总量
    //     spinningChange = Math.random() * 10 + velocity; // 随机顶一个旋转速率
    //     rotateWheel();
    // })
  }
};
</script>

<style lang="less">
.zp {
  position: absolute;
  width: 297.5px;
  height: 297.5px;
  background-image: url('http://cdn.yxvzb.com/WEB/wx-master/images/anyu/bg.png');
  background-size: 100% 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  #canvas {
    position: absolute;
    top: 37px;
    left: 37px;
    // transform: translate(-50%,-50%);
    -o-transform: transform 6s;
    -ms-transform: transform 6s;
    -moz-transform: transform 6s;
    -webkit-transform: transform 6s;
    transition: transform 6s;
    -o-transform-origin: 50% 50%;
    -ms-transform-origin: 50% 50%;
    -moz-transform-origin: 50% 50%;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  #spin_button {
    width: 76px;
    height: 98px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  .close {
    width: 0.64rem /* 48/75 */;
    height: 0.64rem /* 48/75 */;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
